export const validPasswordValidator = (data = "") => {
  // let result = /[A-Za-záéëËíóúÁÉÍÓÚñÑñÑ0-9_]{2,20}/i.exec(data);
  // let noSpace = !/(\W)/g.exec(data);
  // if (result) return result[0].length === data.length && noSpace;
  return true;
};

export const fullSpaces = (data = "") => {
  let spaces = 0;
  for (let i = 0; i < data.length; i++) {
    let result = /\s/g.test(data[i]);
    if (result) spaces++;
  }
  let result = spaces === data.length;
  return result;
};

export const validUserNameValidator = (data = "") => {
  // let result = /[A-Za-záéëËíóúÁÉÍÓÚñÑ0-9_ .]{3,50}/i.exec(data);
  // if (result) return result[0].length === data.length && !fullSpaces(data);
  return true;
};

export const validEmailValidator = (value = "") => {
  // eslint-disable-next-line
  /*
  let result =
    /^([A-Z|a-z|0-9](\.|_){0,1})+[A-Z|a-z|0-9]\@([A-Z|a-z|0-9])+((\.){0,1}[A-Z|a-z|0-9]){3}\.[a-z]{2,3}$/g.exec(
      value
    );
    */
  // if (result) return result[0].length === value.length;
  return true;
};
